import { useEffect, useRef } from "react";

declare global {
  interface Window {
    MNI?: { Widgets: { Member: new (id: string, opts: Record<string, unknown>) => { create: () => void } } };
  }
}

const WIDGET_ID = "mni-membership-639183458405939588";
const SCRIPT_SRC = "https://northportchamber.chambermaster.com/Content/Script/Member.js";

const ChamberBadge = () => {
  const created = useRef(false);

  useEffect(() => {
    if (created.current) return;

    const tryCreate = () => {
      if (created.current) return;
      const el = document.getElementById(WIDGET_ID);
      if (!el || !window.MNI?.Widgets?.Member) return false;
      try {
        new window.MNI.Widgets.Member(WIDGET_ID, {
          member: 4319,
          styleTemplate:
            "#@id{text-align:center;position:relative;width:100%}#@id .mn-widget-member-name{display:none}#@id .mn-widget-member-logo{max-width:100%;max-height:72px;width:auto;height:auto;margin:0 auto;display:block}#@id img{max-height:72px;width:auto}",
        }).create();
        created.current = true;
        return true;
      } catch {
        return false;
      }
    };

    if (tryCreate()) return;

    let script = document.querySelector<HTMLScriptElement>(`script[src="${SCRIPT_SRC}"]`);
    if (!script) {
      script = document.createElement("script");
      script.src = SCRIPT_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
    script.addEventListener("load", tryCreate);

    // Fallback polling in case the script was already loading
    const interval = window.setInterval(() => {
      if (tryCreate()) window.clearInterval(interval);
    }, 400);
    const timeout = window.setTimeout(() => window.clearInterval(interval), 8000);

    return () => {
      script?.removeEventListener("load", tryCreate);
      window.clearInterval(interval);
      window.clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="w-full flex items-center justify-center">
      <div className="w-full" id={WIDGET_ID} />
    </div>
  );
};

export default ChamberBadge;
